import React, { Component } from 'react'
import Graphics from 'components/trash/Graphics';

import './Trash.scss'

import { withTranslation } from 'react-i18next'

class Trash extends Component {
    render() {
        return (
            <ul>
                <li
                  id="Trash" tabIndex={0}
                  className="dropTarget">
                    <p aria-hidden="true" className="label">{this.props.t("Trash")}</p>
                    <Graphics id={this.props.id}/>
                </li>
            </ul>
        );
    }
}

export default withTranslation()(Trash);
